import { handleActions } from 'redux-actions';
import { getLogger } from 'utils/logger';
import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';
import * as actions from './categoryGroupListsActions';

const log = getLogger('data/categoryGroupLists/categoryGroupListsReducer.js');

export const CATEGORY_GROUP_LISTS_REDUCER_KEY = 'categoryGroupListsStore';

const initialState = mkQcsSyncResourceStore();
const categoryGroupListsReducer = handleActions({
  [actions.getCategoryGroupListsAction]: (state) => {
    log.log('getCategoryGroupListsAction...');
    return state.merge({ isLoading: true });
  },
  [actions.getCategoryGroupListsSuccessAction]: (state, { payload }) => {
    log.log('getCategoryGroupListsSuccessAction...\n', payload);
    return upsertResources(state, payload);
  },
  [actions.getCategoryGroupListsFailureAction]:
    (state, { payload: error }) => completeWithError(state, error),

}, initialState);

export default categoryGroupListsReducer;
